import { openPanelChat } from "./panel-chat-connection";

/** Uses the same scoped read protocol as the primary chat, never the global admin list. */
export function readChatHistory(address, token, chatId, cancelToken, connect = openPanelChat) {
  if (!Number.isSafeInteger(chatId) || chatId < 1) return Promise.reject(new Error("شناسه گفتگو معتبر نیست."));
  return new Promise((resolve, reject) => {
    let connection, done = false, page = 1;
    const rows = new Map();
    const timeout = setTimeout(() => finish(new Error("دریافت تاریخچه گفتگو به پایان نرسید؛ دوباره تلاش کنید.")), 20000);
    const cancelled = (reason) => finish(reason);
    function finish(error) {
      if (done) return;
      done = true; clearTimeout(timeout); connection?.close(); cancelToken?.unsubscribe?.(cancelled);
      if (error) reject(error); else resolve([...rows.values()]);
    }
    function next() {
      connection.send(JSON.stringify({ target: "GetMessage", arguments: [{ chatId, page, limit: 100 }] }));
    }
    try {
      cancelToken?.throwIfRequested();
      connection = connect(address, token, {
        onReady: () => { if (!done) next(); },
        onError: (message) => finish(new Error(message)),
        onFrame: (frame) => {
          if (done || frame.target !== "GetMessage") return;
          const payload = frame.arguments?.[1];
          if (Number(payload?.code) !== 200 || !Array.isArray(payload?.data)) {
            finish(new Error(payload?.message || "پاسخ تاریخچه گفتگو معتبر نیست.")); return;
          }
          if ((payload.chatId && Number(payload.chatId) !== chatId) || payload.data.some((row) => Number(row.chatId) !== chatId || !(Number(row.id) > 0))) {
            finish(new Error("پاسخ تاریخچه متعلق به این گفتگو نیست.")); return;
          }
          const previousSize = rows.size;
          payload.data.forEach((row) => rows.set(Number(row.id), row));
          if (payload.data.length < 100) { finish(); return; }
          if (rows.size === previousSize) { finish(new Error("صفحه تکراری در تاریخچه گفتگو دریافت شد.")); return; }
          page++; next();
        },
      });
      cancelToken?.subscribe?.(cancelled);
    } catch (error) { finish(error); }
  });
}
